import SectionHeader from "core/section-header/SectionHeader";
import "./NavigationBar.scss";
import { useContext, useEffect } from "react";
import InfoContext from "pages/InfoContext";
import { useParams } from "react-router-dom";
import { getAccessibleSections } from "access-roles/general-functions";
import { useUserContext } from "api/user/UserProvider";

function NavigationBar() {
  const { sections, setSection, sectionCounts } = useContext(InfoContext);
  const { userRoleList } = useUserContext();
  const { tab } = useParams();

  useEffect(() => {
    tab && setSection(tab);
  }, [tab, sections]);

  const accessibleSections = getAccessibleSections({
    sections,
    userRoles: userRoleList,
  });

  return (
    <div className="navigation-bar">
      {accessibleSections?.map((section) => (
        <div key={section?.section} className="section-parent">
          <SectionHeader
            setSection={setSection}
            section={section?.section}
            icon={section?.icon}
            id={section?.label?.id}
            defaultMessage={section?.label?.defaultMessage}
            count={sectionCounts?.[section?.section]}
          />
        </div>
      ))}
    </div>
  );
}

export default NavigationBar;
